export interface SocialSharingOptions {
  url: string;
  title: string;
  description?: string;
  image?: string;
}

export const socialSharing = {
  /**
   * Share on Facebook
   */
  facebook: (options: SocialSharingOptions) => {
    const { url, title } = options;
    const encodedUrl = encodeURIComponent(url);
    const encodedText = encodeURIComponent(title);
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedText}`;
    window.open(shareUrl, '_blank', 'width=600,height=400');
  },

  /**
   * Share on Twitter/X
   */
  twitter: (options: SocialSharingOptions) => {
    const { url, title } = options;
    const encodedUrl = encodeURIComponent(url);
    const encodedText = encodeURIComponent(title);
    const shareUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}`;
    window.open(shareUrl, '_blank', 'width=600,height=400');
  },

  /**
   * Share on LinkedIn
   */
  linkedin: (options: SocialSharingOptions) => {
    const { url, title } = options;
    const encodedUrl = encodeURIComponent(url);
    const encodedTitle = encodeURIComponent(title);
    const shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedTitle}`;
    window.open(shareUrl, '_blank', 'width=600,height=400');
  },

  /**
   * Share on WhatsApp
   */
  whatsapp: (options: SocialSharingOptions) => {
    const { url, title } = options;
    const encodedUrl = encodeURIComponent(url);
    const encodedText = encodeURIComponent(`${title} ${url}`);
    const shareUrl = `https://wa.me/?text=${encodedText}`;
    window.open(shareUrl, '_blank');
  },

  /**
   * Share via Email
   */
  email: (options: SocialSharingOptions) => {
    const { url, title, description } = options;
    const subject = encodeURIComponent(title);
    const body = encodeURIComponent(`${description || title}\n\nĐọc thêm tại: ${url}`);
    const mailtoUrl = `mailto:?subject=${subject}&body=${body}`;
    window.location.href = mailtoUrl;
  },

  /**
   * Copy URL to clipboard
   */
  copyUrl: async (url: string): Promise<boolean> => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
        return true;
      } else {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = url;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        const result = document.execCommand('copy');
        textArea.remove();
        return result;
      }
    } catch (error) {
      console.error('Failed to copy URL:', error);
      return false;
    }
  },

  /**
   * Get current page URL
   */
  getCurrentUrl: (): string => {
    if (typeof window !== 'undefined') {
      return window.location.href;
    }
    return '';
  },

  /**
   * Generate sharing URL for any platform
   */
  generateShareUrl: (platform: string, options: SocialSharingOptions): string => {
    const { url, title, description } = options;

    switch (platform.toLowerCase()) {
      case 'facebook':
        return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(title)}`;
      case 'twitter':
        return `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`;
      case 'linkedin':
        return `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`;
      case 'whatsapp':
        return `https://wa.me/?text=${encodeURIComponent(`${title} ${url}`)}`;
      case 'email':
        return `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(`${description || title}\n\nĐọc thêm tại: ${url}`)}`;
      default:
        return url;
    }
  },
};

export default socialSharing;
